// Copyright (c) Docugami, Inc. All rights reserved.

import { useEffect, useRef } from "react";
import styled from "styled-components";

const ContentContainer = styled.div`
    position: fixed;
    pointer-events: none;
    z-index: 3;
    cursor: grabbing;
`

const CursorHitTarget = styled.div`
    position: fixed;
    width: 50px;
    height: 50px;
    cursor: grabbing;
    z-index: 1;
`

interface CursorElementProps {
    children: JSX.Element;
    isVisible: boolean;
    offsetX?: number;
    offsetY?: number;
}

export const CursorElement = (props: CursorElementProps): JSX.Element => {
    const contentRef = useRef<HTMLDivElement | null>(null);
    const hitRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const onPointerMove = (ev: PointerEvent) => {
            if (!contentRef.current || !hitRef.current) {
                return;
            }

            hitRef.current.style.top = ev.pageY - 25 + 'px';
            hitRef.current.style.left = ev.pageX - 25 + 'px';

            contentRef.current.style.top = ev.pageY - (props.offsetY ?? 0) + 'px';
            contentRef.current.style.left = ev.pageX + (props.offsetX ?? 0) + 'px';
        }

        if (props.isVisible) {
            document.addEventListener("pointermove", onPointerMove);

            return () => {
                document.removeEventListener("pointermove", onPointerMove);
            }
        }
    }, [props.isVisible, props.offsetX, props.offsetY]);

    return (props.isVisible ?
        <>
            <ContentContainer ref={contentRef}>
                {props.children}
            </ContentContainer>
            <CursorHitTarget ref={hitRef}/>
        </> :
        <></>
    )
}
